<ng-container *ngIf="contentType === 'user-service'">
  <app-user-service
    [service]="gridCardService.contentLikeUserService(content)"
    [view]="'horizontal'"
    (openInModal)="onToggleInModal($event)">
  </app-user-service>
</ng-container>
<ng-container *ngIf="contentType === 'collections'">
  <app-collection
    [collection]="gridCardService.contentLikeCollection(content)"
    [view]="'horizontal'"
    (openInModal)="onToggleInModal($event)"></app-collection>
</ng-container>
<ng-container *ngIf="contentType === 'tutors'">
  <app-tutors
    [user]="gridCardService.contentLikeUser(content)"
    [view]="'horizontal'"
    (openInModal)="onToggleInModal($event)"></app-tutors>
</ng-container>
<ng-container *ngIf="contentType === 'school'">
  <app-school
    [school]="gridCardService.contentLikeCSchool(content)"
    [view]="'horizontal'"
    (openInModal)="onToggleInModal($event)"></app-school>
</ng-container>
<ng-container *ngIf="contentType === 'lesson'">
  <app-lesson
    [content]="gridCardService.contentLikeContent(content)"
    [view]="'horizontal'"
    (openInModal)="onToggleInModal($event)"></app-lesson>
</ng-container>
